
import React from 'react';
import { Check } from 'lucide-react';

interface IntegrationFeaturesListProps {
  features: string[];
}

const IntegrationFeaturesList: React.FC<IntegrationFeaturesListProps> = ({ features }) => (
  <ul className="space-y-1 text-sm">
    {features.map(feature => (
      <li className="flex text-gray-600" key={feature}>
        <Check className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
        <span>{feature}</span>
      </li>
    ))}
  </ul>
);

export default IntegrationFeaturesList;
